import { useCallback, useEffect, useState } from "react";
import { CustomModal } from "../../../components/CustomModal";
import { useTranslation } from "react-i18next";
import { MDBBtn } from "mdb-react-ui-kit";
import { Alert } from "../../../components/Alert";
import { LoadingSpinner } from "../../../components/LoadingSpinner";
import API from "../../../service/api";

export interface ActivateMachineModalProps {
    machineId: number;
    open: boolean;
    onClose: () => void;
}

export const ActivateMachineModal = ({machineId, open, onClose}: ActivateMachineModalProps) => {
    const { t } = useTranslation();
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState('');

    useEffect(() => {
        if (!open) return;
        setError('');
        setLoading(false);
    }, [open, machineId]);

    const confirm = useCallback(async () => {
        setLoading(true);
        setError('');
        setSuccess('');

        try {
            await API.POST(`/api/admmachines/${machineId}/activate`);
            setSuccess(t('machine:activate_success'));
        }catch(err: any){
            setError(err.message);
        }finally{
            setLoading(false);
        }
    }, []);

    return (
        <CustomModal
            open={open}
            onClose={onClose}
            title={t('machine:activate')}
            footer={( (error || success)
                ? <MDBBtn color="secondary" className="w-100" onClick={onClose}>{t('close')}</MDBBtn>
                : <>
                    <MDBBtn color="secondary" onClick={onClose}>{t('cancel')}</MDBBtn>
                    <MDBBtn color="danger" onClick={confirm} disabled={loading}>{t('confirm')}</MDBBtn>
                </>
            )}
        >
            <div className="d-flex flex-column justify-content-center align-items-center w-100">
                {loading && <LoadingSpinner/>}
                {!loading !== null && (
                    <div className="d-flex flex-column">
                        {(!error && !success) && <span>{t('machine:activate_prompt')}</span>}
                        <Alert type="danger" message={error}/>
                        <Alert type="success" message={success}/>
                        
                    </div>
                )}
            </div>

        </CustomModal>
    )
}